import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/path/styles.scss';export default {
  "path": "_path_114l1_1",
  "item": "_item_114l1_9",
  "project": "_project_114l1_26",
  "dropZone": "_dropZone_114l1_30"
};